import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Typography, IconButton, Chip } from '@mui/material';
import { Delete as DeleteIcon, DragIndicator } from '@mui/icons-material';
import { SortableGroupItemProps } from './types';
import styles from './SortableGroupItem.module.scss';

const SortableGroupItem: React.FC<SortableGroupItemProps> = ({
  group,
  isActive,
  isModified,
  onClick,
  onDelete,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: group.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      className={`${styles.groupItem} ${isActive ? styles.active : ''} ${isDragging ? styles.dragging : ''}`}
      onClick={onClick}
    >
      <Box className={styles.dragHandle} {...attributes} {...listeners}>
        <DragIndicator sx={{ fontSize: 20, color: 'text.secondary' }} />
      </Box>

      <Typography
        sx={{
          flex: 1,
          fontSize: '0.875rem',
          color: 'text.primary',
          fontWeight: 500,
        }}
      >
        {group.name}
        <Typography
          component="span"
          sx={{ ml: 1, fontSize: '0.75rem', color: 'text.secondary' }}
        >
          ({group.rowIds?.length || 0} items)
        </Typography>
        {isActive && isModified && (
          <Chip
            label="Modified"
            size="small"
            color="warning"
            sx={{ ml: 1, height: 20, fontSize: '0.7rem' }}
          />
        )}
      </Typography>

      <IconButton
        size="small"
        onClick={e => {
          e.stopPropagation();
          onDelete();
        }}
        sx={{ color: 'text.secondary' }}
      >
        <DeleteIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Box>
  );
};

export default SortableGroupItem;
